import React from 'react'
import styled from 'styled-components'
import { gaPath } from '../ga'

import logo from '../../assets/images/Logo-tm-white.png'

const Brand = () => {
  return (
    <Image
      onClick={event => {
        window.location.href = '/#'
        gaPath('/')
      }}
      src={logo}
      alt="4HisGlory! Logo"
      tabIndex="0"
      onKeyDown={() => {
        window.location.href = '/#'
        gaPath('/')
      }}
      role="img"
    />
  )
}

export default Brand

const Image = styled.img`
  height: 65%;
  margin: auto 0;
  cursor: pointer;
`
